import React from "react"
import HeadTitle from "../../common/HeadTitle/HeadTitle";
import AllBlog from "./AllBlog"

const Blog = () => {
  return (
    <>
      <HeadTitle />
      <AllBlog />
    </>
  )
}

export default Blog